module.exports = __webpack_public_path__ + "img/0220809161005.ab437cc7.jpg";